import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuth } from "../config/axiosInstance";
import { PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL } from "../config/api_config";
import { resolveCourseId } from "../utilities/videoPlayerApi";
import { fetchUserActivityUpdate } from "./updateUserActivitySlice";

export const fetchCourseModule = createAsyncThunk(
    'courseModule/fetchCourseModule',
    async ({ course_id } = {}, { getState }) => {
        const courseId = resolveCourseId(getState(), course_id);
        const response = await axiosAuth.get(
            `${PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL}/api/v1/courses/${courseId}`
        );
        return response.data;
    }
);

export const fetchModuleCurationStatus = createAsyncThunk(
    'courseModule/fetchModuleCurationStatus',
    async ({ course_id, module_slug }, { getState, signal }) => {
        const courseId = resolveCourseId(getState(), course_id);
        const response = await axiosAuth.get(
            `${PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL}/api/v1/courses/${courseId}/modules/${encodeURIComponent(module_slug)}/curation-status`,
            { signal }
        );
        return response.data;
    }
);

const courseModuleSlice = createSlice({
    name: 'courseModule',
    initialState: {},
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCourseModule.fulfilled, (state, action) => action.payload)
            .addCase(fetchUserActivityUpdate.fulfilled, (state, action) => action.payload.course);
    },
});

export const selectCourseModule = (state) => state?.courseModule;
export const selectCourseModuleContent = (state) => state?.courseModule?.course_data;
export const selectCourseProgress = (state) => state?.courseModule?.course_progress ?? 0;
export const selectModuleBySlug = (state, moduleSlug) =>
    state?.courseModule?.course_data?.find((module) => module?.module_slug === moduleSlug);
export const selectLessonBySlugs = (state, moduleSlug, lessonSlug) =>
    selectModuleBySlug(state, moduleSlug)?.module_content?.find((lesson) => lesson?.lesson_slug === lessonSlug);
export const selectCompletedLessonCount = (state, moduleSlug) =>
    selectModuleBySlug(state, moduleSlug)?.module_content?.filter((lesson) => lesson?.lesson_status === 'completed')?.length ?? 0;
export default courseModuleSlice.reducer;
